function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.4775503 3.86588858c3.0403172 1.25610483 5.023206 4.22153133 5.0224497 7.51110922.0019724 2.0398505-.7489345 3.9049385-1.9906018 5.3320758l.0146018.0149264.1725296-.169668c.2376963-.2354107.6206599-.2354107.8583562 0l3.842573 3.8056252c.2393297.2370285.2411953.6231932.0041668.8625229l-.0041668.0041668-1.0040149.9943609c-.2376963.2354108-.6206598.2354108-.8583561 0l-3.842573-3.8056252c-.2393298-.2370285-.2411953-.6231932-.0041668-.8625229l.0041668-.0041668.1644852-.1636929c-1.4402173 1.3067301-3.3494707 2.1084017-5.446721 2.115-3.28954799.0141605-6.26307399-1.9565622-7.53162437-4.991707-1.26855039-3.0351448-.58176852-6.53570631 1.73954528-8.86654916s5.81903319-3.0319601 8.85935039-1.77585526zm-3.0620248 1.55091634c-2.41331239-.01638388-4.59815714 1.42464249-5.53325533 3.64948902-.9350982 2.22484656-.43573977 4.79403896 1.26465633 6.50663976 1.70039609 1.7126009 4.2659503 2.2303198 6.4974259 1.3111555s3.6880887-3.0936492 3.6889809-5.5070184c.0078256-3.27844108-2.6393962-5.94466359-5.9178078-5.96026588z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#666",
  fillRule: "evenodd",
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h26v26h-26z"
}));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.9331100a.svg";
export { ForwardRef as ReactComponent };